import { render, staticRenderFns } from "./GoodsComponent.vue?vue&type=template&id=ebf85cd0&scoped=true&"
import script from "./GoodsComponent.vue?vue&type=script&lang=js&"
export * from "./GoodsComponent.vue?vue&type=script&lang=js&"
import style0 from "./GoodsComponent.vue?vue&type=style&index=0&id=ebf85cd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf85cd0",
  null
  
)

export default component.exports